import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import "./theme.css";
import "./Footers.css";
import logo from "./logo.png";
import { isPortalUserLoggedIn } from "./auth";

const BASE_PATH = (process.env.REACT_APP_BASE_PATH || "/als").replace(/\/+$/, "");

export function CompactFooter() {
  return (
    <footer className="als-footer als-footer--compact">
      <div className="als-footer-inner">
        <div className="als-footer-bottom">
          <span>
            © {new Date().getFullYear()} Open Learnings. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default function Footers() {
  if (isPortalUserLoggedIn()) {
    return <CompactFooter />;
  }

  return (
    <footer className="als-footer">
      <div className="als-footer-inner">
        <div className="als-footer-grid">
          <div className="als-footer-brand">
            <Link to="/" className="als-brand">
              <img src={logo} alt="Open Learnings" className="als-brand-logo" />
              <span className="als-brand-text">Open Learnings</span>
            </Link>
            <p>
              Your trusted partner in professional training, internships and
              lifelong learning.
            </p>
            <div className="als-footer-social">
              <a href="https://linkedin.com" aria-label="LinkedIn" target="_blank" rel="noreferrer">
                <FaLinkedinIn />
              </a>
              <a href="https://twitter.com" aria-label="Twitter" target="_blank" rel="noreferrer">
                <FaTwitter />
              </a>
              <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>
            </div>
          </div>

          <div className="als-footer-col">
            <h4>Explore</h4>
            <ul>
              <li><a href={`${BASE_PATH}/courses`}>Courses</a></li>
              <li><a href={`${BASE_PATH}/trainers`}>Trainers</a></li>
              <li><a href={`${BASE_PATH}/internships`}>Internships</a></li>
              <li><a href={`${BASE_PATH}/institutions`}>Institutes</a></li>
              <li><a href={`${BASE_PATH}/employers`}>Employers</a></li>
            </ul>
          </div>

          <div className="als-footer-col">
            <h4>Get Involved</h4>
            <ul>
              <li><a href={`${BASE_PATH}/trainers`}>Become a Trainer</a></li>
              <li><a href={`${BASE_PATH}/institution-signin`}>List Your Institute</a></li>
              <li><a href={`${BASE_PATH}/employer-signin`}>Hire Interns</a></li>
              <li><a href={`${BASE_PATH}/contact`}>Partner With Us</a></li>
            </ul>
          </div>

          <div className="als-footer-col">
            <h4>Resources</h4>
            <ul>
              <li><a href={`${BASE_PATH}/contact`}>Contact Us</a></li>
              <li><a href={`${BASE_PATH}/#faq`}>FAQs</a></li>
              <li><a href={`${BASE_PATH}/trainee-signin`}>Help Center</a></li>
              <li><a href={`${BASE_PATH}/privacy-policy`}>Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="als-footer-bottom">
          <span>
            © {new Date().getFullYear()} Open Learnings. All rights
            reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
